import { render } from "./clientprofilemodal.vue?vue&type=template&id=3d064778"
import script from "./clientprofilemodal.vue?vue&type=script&lang=js"
export * from "./clientprofilemodal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__